import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Controller, useFieldArray, useForm } from "react-hook-form";

import Select from "react-select";
import "react-folder-tree/dist/style.css";
import {
  addNewReceipt,
  getAccountledger,
  getcashorbank,
  getReceiptByGuid,
} from "../../services/AccountApiServices.js";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { ReceiptEntry } from "../../core/json/ReceiptEntry.js";
import { Company } from "../../core/json/Company.js";
import { getCurrencyList } from "../../services/MasterApiServices.js";
import {
  Check,
  Plus,
  Printer,
  RotateCcw,
  Trash2,
} from "feather-icons-react/build/IconComponents/index.js";
import "../../style/css/sales-invoice-terminal.css";
import {
  useTerminalChrome,
  TermCmdBar,
  TermColumns,
  TermStatusBar,
} from "../transactions/terminal/TerminalChrome";
import { FinancialYear } from "../../core/json/FinancialYear.js";
import { Currency } from "../../core/json/Currency.js";
import { fetchBranchSettings } from "../../redux/settingbyBranch.js";
import dayjs from "dayjs";
import { DatePicker } from "antd";
import { getPrintSettingsByBranch } from "../../services/AdminApiServices.js";

const Receipt = ({ mode, data, handleClose, handleRefresh }) => {
  const dispatch = useDispatch();
  const { branch } = useSelector((state) => state.branchlist);
  const { companyInfolist } = useSelector((state) => state.companyInfo);
  const { userId } = useSelector((state) => state.userauth);
  const [ledgerData, setLedgerData] = useState();
  const [currencyData, setCurrencyData] = useState();
  const [isRowAdded, setIsRowAdded] = useState(false);
  const [printAfterSubmit, setPrintAfterSubmit] = useState(false); // New state variable
  const { branchsettings } = useSelector((state) => state.settings);
  const [cashorbank, setcashorbank] = useState();
const [printSettings, setPrintSettings] = useState([]); 
  
  const { register, handleSubmit, setValue, getValues, watch, control, reset } =
    useForm({
      mode: "onChange",
      reValidateMode: "onChange",
    });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "items",
  });

  
  useEffect(() => {
    handleLedgerList();
    handleCurrencyList();
    handlecashorbankList();
    // handleAddRow()

    dispatch(fetchBranchSettings(branch.guid));
  }, []);

  useEffect(() => {
    if (mode === "add") {
      handleEntryNo();
      if (!isRowAdded && fields?.length === 0) {
        handleAddRow();
        setIsRowAdded(true);
      }
    }
  }, []);

  useEffect(() => {
    resetmodal();
  }, [data, data.ledgerID]);

  useEffect(() => {
  const fetchPrintSettings = async () => {
    try {
      const response = await getPrintSettingsByBranch(branch?.guid);
      setPrintSettings(response);
    } catch (error) {
      console.error("Failed to fetch print settings", error);
    }
  };

  if (branch?.guid) {
    fetchPrintSettings();
  }
}, [branch]);

  const handleAddRow = () => {
    append({
      narration: "",
      amount: "0",
      ledgerID: null,
    });
  };

  const handleEntryNo = async () => {
    try {
      const response = await getReceiptByGuid(branch, 0);
      const receiptData = response;
      // Find the maximum number from the existing entries
      const maxEntryNumber =
        receiptData?.length > 0
          ? receiptData
              ?.map((data) => parseInt(data.no))
              ?.reduce((max, num) => Math.max(max, num), 0) // Find the maximum number
          : 0;
      let counter = maxEntryNumber + 1;
      setValue(`no`, counter);
      counter++;
    } catch (error) {
      console.error("Failed to fetch purchase invoices", error);
    }
  };

  function resetmodal() {
    if (mode === "edit" && data) {
      const resetData = {
        no: data?.no,
        narration: data?.narration,
        cash: data?.ledgerID,
        amount: data?.amount,
        date: dayjs(data?.date),
        items: data?.receiptDetails?.map((detail) => ({
          ledgerID: detail?.ledgerID,
          narration: detail?.narration,
          amount: detail?.amount,
        })),
      };
      
    const total = resetData.items.reduce(
      (acc, item) => acc + (parseFloat(item.amount) || 0),
      0
    );
    resetData.totalAmt = total; // Set totalAmt correctly

      reset(resetData);
    } else {
      reset();
      handleEntryNo();
    }
  }

  const handleFormSubmit = async (formdata) => {
    console.log("Submitting Form Data:", formdata); // Debugging the form data
    const objreceipt = new ReceiptEntry();
    if (mode === "edit") {
      objreceipt.guid = data.guid;
      objreceipt.id = data.id;
    }
    const objfinancialyear = new FinancialYear();
    const objcurrency = new Currency();
    objcurrency.guid = branchsettings?.primaryCurrencyGUID;
    objfinancialyear.guid = branchsettings?.defaultFinancialYearGuID;
    objreceipt.FinancialYear = objfinancialyear;
    objfinancialyear.id = branchsettings?.defaultFinancialYearID;
    objreceipt.No = formdata.no;
    objreceipt.Date = formdata.date
      ? dayjs(formdata.date).format("YYYY-MM-DD")
      : dayjs().format("YYYY-MM-DD");
    objreceipt.LedgerID = formdata.cash;
    objreceipt.TotalAmt = formdata.totalAmt;
    objreceipt.Narration = formdata.narration;
    objreceipt.IsCheque = false;
    objreceipt.Currency = objcurrency;
    objreceipt.CurrencyRate = 0;
    objreceipt.Branch = branch;
    objreceipt.updatedUser = `{${userId?.id}}`;
    objreceipt.Company = companyInfolist[0];

    const detailObj = formdata?.items?.map((e) => ({
      ledgerID: e.ledgerID,
      Amount: e.amount,
      Narration: e.narration,
    }));

    objreceipt.receiptDetails = detailObj;
    console.log("Final Request Payload:", objreceipt); // Log the final payload
    try {
      const response = await addNewReceipt(objreceipt);
      console.log("API Response:", response); // Debug the response

      if (response.data === true) {
        toast.success("Success");
        handleRefresh(); // Refresh the list
        handleClose();
                                 if (printAfterSubmit) {
           printA4Function();      // 👈 only called if user clicked "Save & Print"
           setPrintAfterSubmit(false); // reset flag
         }
      } else {
        toast.error("Operation failed");
      }
    } catch (error) {
      toast.error(error?.response?.data?.Message || "Something went wrong");
      console.error("Error handling receipt:", error);
    }
  };

  const printA4Function = () => {
  const formValues = watch();
  const fields = formValues?.items || [];
 const totalNet = Number(formValues?.totalAmt || 0);

  // const company = companyInfolist?.[0] || {};
  // const companyName = company.name || "Company Name";
  // const companyAddress1 = company.address1 || "";
  // const companyAddress2 = company.address2 || "";
  // const companyAddress3 = company.address3 || "";
  // const companyPhone = company.phone || "";
  // const companyEmail = company.email || "-";

  const company = printSettings?.[0] ?? {};

console.log("Company Info for Printing:", company); 
    // Extract company details
    const companyName = company.companyName;
    const otherLanguage = company.otherLanguage || "";
    const companyAddress1 = company.header1 || "";
    const companyAddress2 = company.header2 || "";
    const companyAddress3 = company.header3 || "";
    const companyAddress4 = company.header4 || "";
    const companyAddress5 = company.header5 || "";

  const entryNumber = formValues.no || "-";
  const cashOrBank = cashorbank?.find(item => item.value === formValues.cash)?.label || "-";
  const date = formValues.date
    ? dayjs(formValues.date).format("DD/MM/YYYY")
    : dayjs().format("DD/MM/YYYY");
  const narration = formValues.narration || "-";

  const tableRows = fields.map((row, index) => {
    const ledgerName = ledgerData?.find(ld => ld.value === row.ledgerID)?.label || "-";
    return `
      <tr>
        <td>${index + 1}</td>
        <td>${ledgerName}</td>
        <td style="text-align:right;">${parseFloat(row.amount || 0).toFixed(2)}</td>
        <td>${row.narration || "-"}</td>
      </tr>
    `;
  });

  const printableContent = `
  <html>
    <head>
      <style>
        * { box-sizing: border-box; }
        body {
          font-family: Arial, sans-serif;
          font-size: 12px;
          margin: 20px;
          position: relative;
          min-height: 100%;
        }
        h2, h3 { margin: 0; }
        table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 15px;
        }
        th, td {
          border: 1px solid #000;
          padding: 6px;
        }
        .header {
          text-align: center;
          margin-bottom: 10px;
        }
        .info-table td {
          padding: 4px;
          border: none;
          text-align: left;
        }
        .text-right {
          text-align: right;
        }
        .footer-signatures {
          margin-top: 100px;
          display: flex;
          justify-content: space-between;
        }
        .footer-column {
          width: 30%;
          text-align: center;
          flex : 1;
        }
      </style>
    </head>
    <body>
      <div class="header">
    <h2>${otherLanguage}</h2>
  <h2>${companyName}</h2>
 
  <p>${companyAddress1}</p>
  <p>${companyAddress2}</p>
  <p>${companyAddress3}</p>
  <p>${companyAddress4}</p>
  <p>${companyAddress5}</p>
      </div>

      <h3 style="text-align:center;">RECIEPT VOUCHER</h3>

      <table class="info-table">
        <tr>
          <td><strong>Voucher No:</strong> ${entryNumber}</td>
          <td><strong>Date:</strong> ${date}</td>
        </tr>
        <tr>
          <td><strong>Paid From:</strong> ${cashOrBank}</td>
          <td><strong>Total Amount:</strong> ${parseFloat(totalNet).toFixed(2)}</td>
        </tr>
        <tr>
          <td colspan="2"><strong>Remarks:</strong> ${narration}</td>
        </tr>
      </table>

      <table>
        <thead>
          <tr>
            <th>S.No</th>
            <th>Ledger</th>
            <th>Amount</th>
            <th>Narration</th>
          </tr>
        </thead>
        <tbody>
          ${tableRows.join("")}
        </tbody>
      </table>

      <div class="footer-signatures">
        <div class="footer-column">
          <p>Approved By</p>
          <br /><br />
          <p>-----------------------</p>
        </div>
        <div class="footer-column">
          <p>Accountant Signature</p>
          <br /><br />
          <p>-----------------------</p>
        </div>
        <div class="footer-column">
          <p>Received By</p>
          <br /><br />
          <p>-----------------------</p>
        </div>
      </div>
    </body>
  </html>
  `;

  const iframe = document.createElement("iframe");
  iframe.style.position = "absolute";
  iframe.style.width = "0px";
  iframe.style.height = "0px";
  iframe.style.border = "none";
  document.body.appendChild(iframe);

  const doc = iframe.contentWindow.document;
  doc.open();
  doc.write(printableContent);
  doc.close();

  iframe.contentWindow.focus();
  setTimeout(() => {
    iframe.contentWindow.print();
    iframe.contentWindow.onafterprint = () => document.body.removeChild(iframe);
  }, 500);
};


  const handleLedgerList = async () => {
    try {
      const response = await getAccountledger();

      if (Array.isArray(response)) {
        setLedgerData(
          response?.map((e) => ({
            value: e.guid,
            label: e.name,
          }))
        );
      }
    } catch (error) {
      console.error(
        error?.response?.data?.Message || "Error fetching ledger data"
      );
      setLedgerData([]);
    }
  };
  const handlecashorbankList = async () => {
    try {
      const response = await getcashorbank();
      if (Array.isArray(response?.data)) {
        setcashorbank(
          response?.data?.map((e) => ({
            value: e.guid,
            label: e.name,
          }))
        );
      } else {
        setcashorbank([]);
      }
    } catch (error) {
      setcashorbank([]);
    }
  };
  const handleCurrencyList = async () => {
    try {
      const response = await getCurrencyList();

      if (Array.isArray(response)) {
        setCurrencyData(response);
      } else {
        setCurrencyData([]);
      }
    } catch (error) {
      setCurrencyData([]);
    }
  };
  const handleAmount = (value, index) => {
    // Update the amount for the specific item
    setValue(`items[${index}].amount`, value);

    // Calculate the total by summing all item amounts
    const items = getValues("items"); // Assume getValues fetches the current list of items
    let total = items?.reduce(
      (acc, item) => acc + (parseFloat(item.amount) || 0),
      0
    );

    // Update the total                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       
    setValue("totalAmt", total);
  };
  const handleTotal = () => {
    const items = getValues("items"); // Retrieve the current list of items
    let total = items?.reduce(
      (acc, item) => acc + (parseFloat(item.amount) || 0),
      0
    );

    // Update the total field with the new calculated value
    setValue("totalAmt", total);
  };

  // Define the onClick function to remove an item and update the total
  const handleRemove = (index) => {
    remove(index); // Remove the item at the specified index
    handleTotal(); // Recalculate the total after the item is removed
  };

  // react-select menus render into this node inside .si-term, so they pick
  // up the terminal's colour tokens like everything else
  const [menuHost, setMenuHost] = useState(null);
  const siSelectStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 11000 }),
    menu: (base) => ({ ...base, zIndex: 11000 }),
  };

  // view preferences only - theme, full screen
  const chrome = useTerminalChrome("receipt");
  const docDate = watch("date");
  const cashValue = watch("cash");
  const cashName = cashorbank?.find((c) => c.value === cashValue)?.label;
  const totalShown = (parseFloat(watch("totalAmt")) || 0).toFixed(2);

  return (
    <div
      className="modal fade show si-term si-term--txn"
      data-si-theme={chrome.theme}
      style={{ display: "block" }}
      tabIndex="-1"
    >
      <div className="modal-dialog si-dialog">
        <div className="modal-content si-content">
          <form className="si-form" onSubmit={handleSubmit(handleFormSubmit)}>
            <div className="si-grid">
              <div className="si-left">
                {/* ============ COMMAND BAR ============ */}
                <TermCmdBar
                  chrome={chrome}
                  title="Receipt"
                  docNo={watch("no")}
                  state={
                    mode === "edit"
                      ? { key: "edit", label: "Editing" }
                      : { key: "new", label: "New" }
                  }
                  onBack={handleClose}
                />
                {/* entry no. is generated - the header shows it */}
                <input
                  type="text"
                  className="si-offscreen"
                  tabIndex={-1}
                  aria-hidden="true"
                  {...register("no")}
                  required
                  disabled
                />

                {/* ============ HEADER FIELDS ============ */}
                <section className="si-strip">
                  <div className="si-strip-row si-strip-row--auto">
                    <div className="si-fld">
                      <label>Date</label>
                      <Controller
                        control={control}
                        name="date"
                        render={({ field: { onChange, value } }) => (
                          <DatePicker
                            className="si-date"
                            value={value ? dayjs(value) : dayjs()} // Set value or default to today
                            format="DD-MM-YYYY"
                            onChange={(date) =>
                              onChange(date ? date.format("YYYY-MM-DD") : null)
                            } // Update on change
                          />
                        )}
                      />
                    </div>
                    <div className="si-fld">
                      <label>
                        Cash/Bank <span className="si-req">*</span>
                      </label>
                      <Controller
                        control={control}
                        name={`cash`}
                        render={({ field: { onChange, value } }) => (
                          <Select
                            classNamePrefix="react-select"
                            options={cashorbank}
                            isClearable
                            placeholder="Cash/Bank"
                            value={
                              cashorbank?.find(
                                (cashorbank) => cashorbank?.value === value
                              ) || null
                            }
                            onChange={(selectedOption) =>
                              onChange(selectedOption?.value || null)
                            }
                            menuPortalTarget={menuHost}
                            menuPosition="fixed"
                            styles={siSelectStyles}
                            required
                          />
                        )}
                      />
                    </div>
                    <div className="si-fld si-fld--wide">
                      <label>Remarks</label>
                      <input
                        type="text"
                        className="si-in"
                        placeholder="Note for this receipt"
                        {...register("narration")}
                      />
                    </div>
                  </div>
                </section>

                {/* ============ LINES ============ */}
                <section className="si-lines">
                  <TermColumns chrome={chrome} columns={[]}>
                    <button
                      type="button"
                      className="si-iconbtn"
                      onClick={handleAddRow}
                    >
                      <Plus />
                      <span>Add line</span>
                    </button>
                    <button
                      type="button"
                      className="si-iconbtn"
                      onClick={() => resetmodal()}
                    >
                      <RotateCcw />
                      <span>Reset</span>
                    </button>
                  </TermColumns>

                  <div className="si-tablewrap">
                    <table className="si-table" style={{ minWidth: "640px" }}>
                      <thead>
                        <tr>
                          <th style={{ width: "280px" }}>Ledger</th>
                          <th className="n" style={{ width: "130px" }}>
                            Amount
                          </th>
                          <th>Narration</th>
                          <th style={{ width: "44px" }} aria-label="Line actions" />
                        </tr>
                      </thead>
                      <tbody>
                        {fields?.map((obj, index) => {
                          return (
                            <tr className="si-line" key={index}>
                              <td data-label="Ledger">
                                <Controller
                                  control={control}
                                  name={`items[${index}].ledgerID`}
                                  render={({ field: { onChange, value } }) => (
                                    <Select
                                      isClearable
                                      classNamePrefix="react-select"
                                      className="si-itemsel"
                                      placeholder="Ledger"
                                      options={ledgerData}
                                      value={
                                        ledgerData?.find(
                                          (option) => option?.value === value
                                        ) || null
                                      }
                                      onChange={(selectedOption) => {
                                        onChange(selectedOption?.value) || null;
                                      }}
                                      menuPortalTarget={menuHost}
                                      menuPosition="fixed"
                                      styles={siSelectStyles}
                                      required
                                    />
                                  )}
                                />
                              </td>
                              <td className="n" data-label="Amount">
                                <input
                                  type="text"
                                  inputMode="decimal"
                                  className="si-cellin"
                                  {...register(`items[${index}].amount`)}
                                  onChange={(e) =>
                                    handleAmount(e.target.value, index)
                                  }
                                />
                              </td>
                              <td data-label="Narration">
                                <input
                                  type="text"
                                  className="si-cellin si-cellin--text"
                                  placeholder="—"
                                  {...register(`items[${index}].narration`)}
                                />
                              </td>
                              <td>
                                <div className="si-rowacts">
                                  <Link
                                    to="#"
                                    className="si-rowbtn si-rowbtn--del confirm-text"
                                    title="Remove line"
                                    aria-label="Remove line"
                                    onClick={() => handleRemove(index)}
                                  >
                                    <Trash2 />
                                  </Link>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                    {fields?.length === 0 && (
                      <div className="si-empty">
                        <p className="big">No lines yet</p>
                        <p>Press Add line to start the receipt.</p>
                      </div>
                    )}
                  </div>

                  <div className="si-lines-foot">
                    <span>
                      Lines <b>{fields.length}</b>
                    </span>
                    <span>
                      Total <b>{totalShown}</b>
                    </span>
                  </div>
                </section>

                {/* ============ STATUS BAR ============ */}
                <TermStatusBar
                  context={[
                    cashName,
                    docDate ? dayjs(docDate).format("DD-MM-YYYY") : null,
                  ]}
                />
              </div>

              {/* ============ RAIL ============ */}
              <aside className="si-rail">
                <div className="si-rail-scroll">
                  <div className="si-card">
                    <div className="si-card-h">
                      <span>Received into</span>
                      <span className="r">
                        {docDate ? dayjs(docDate).format("DD-MM-YYYY") : ""}
                      </span>
                    </div>
                    <div className="si-party">
                      <div className="nm">{cashName || "No cash/bank selected"}</div>
                      <div className="meta">
                        {cashName
                          ? `Receipt ${watch("no") || "—"}`
                          : "Pick the cash or bank account to start"}
                      </div>
                    </div>
                  </div>

                  <div className="si-card">
                    <div className="si-card-h">Summary</div>
                    <div className="si-tot">
                      <div className="si-tr">
                        <span className="l">Lines</span>
                        <span className="v">{fields.length}</span>
                      </div>
                      <div className="si-tr si-tr--edit">
                        <span className="l">Total</span>
                        <span className="v">
                          <input
                            type="text"
                            inputMode="decimal"
                            {...register("totalAmt")}
                          />
                        </span>
                      </div>
                    </div>
                    <div className="si-net">
                      <span className="l">Total received</span>
                      <span className="v" title={totalShown}>
                        {totalShown}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="si-actions">
                  <button
                    type="submit"
                    className="si-btn si-btn--primary"
                    onClick={() => setPrintAfterSubmit(true)} // 👈 set flag before submit
                  >
                    <Printer />
                    <span>Save &amp; print</span>
                  </button>
                  <button type="submit" className="si-btn si-btn--ghost">
                    <Check />
                    <span>Save only</span>
                  </button>
                </div>
              </aside>
            </div>
          </form>
        </div>
      </div>
      {/* react-select menus portal here so they inherit the .si-term tokens */}
      <div ref={setMenuHost} className="si-menu-host" />
    </div>
  );
};

export default Receipt;
